<div class="procedure-panel" [dir]="curentLang === 'ar' || curentLang === 'he' ? 'rtl' : 'ltr'">
  <div *ngIf="hasChosenProcedure" class="procedure-panel__status">
    <span class="procedure-panel__status-label">{{ 'invoices_v2.procedure.current_procedure' | translate }}</span>
    <span class="procedure-panel__status-value">{{ procedureLabel }}</span>
  </div>

  <ng-container *ngIf="availableOptions.length; else noActions">
    <div class="procedure-panel__alert">
      <span [innerHTML]="'allocationDenial.alert.message' | translate"></span>
    </div>
    <p class="procedure-panel__cta" [innerHTML]="'allocationDenial.alert.cta' | translate"></p>

    <label
      *ngFor="let option of availableOptions"
      class="procedure-option"
      [class.procedure-option--selected]="selectedOption === option.id"
      (click)="selectOption(option.id)"
    >
      <input type="radio" name="procedureOption" [checked]="selectedOption === option.id" />
      <div class="procedure-option__content">
        <div class="procedure-option__title">{{ option.titleKey | translate }}</div>
        <small class="procedure-option__description">{{ option.descriptionKey | translate }}</small>
      </div>
    </label>

    <button
      type="button"
      class="procedure-panel__btn procedure-panel__btn--primary"
      [disabled]="!selectedOption || isSubmitting"
      (click)="onContinue()"
    >
      {{ 'allocationDenial.buttons.continue' | translate }}
    </button>
    <button type="button" class="procedure-panel__btn procedure-panel__btn--secondary" (click)="onNotDecided()">
      {{ 'allocationDenial.buttons.cancel' | translate }}
    </button>
  </ng-container>

  <ng-template #noActions>
    <p class="procedure-panel__empty">{{ 'invoices_v2.procedure.no_actions' | translate }}</p>
  </ng-template>
</div>
